import { HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BrandingConfigurationService } from '@ptl/brand';
import { HTTPWrapperContext, RequestConfigImplementation, REQUEST_METHODS, XHR_STRATEGIES } from '@ptl/xhr';

interface FormControls {
  npn1: AbstractControl;
  npn2: AbstractControl;
  ffm1: AbstractControl;
  ffm2: AbstractControl;
  attestation: AbstractControl;
}
interface FormControlsAsJson {
  npn1: string;
  npn2: string;
  ffm1: string;
  ffm2: string;
  attestation: boolean;
}
@Component({
    selector: 'app-npn-and-ffmchange-modal',
    templateUrl: './npn-and-ffmchange-modal.component.html',
    styleUrls: ['./npn-and-ffmchange-modal.component.scss'],
    standalone: false
})
export class NpnAndFFMChangeModalComponent implements OnInit {

  npnAndFFMChangeForm: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,
    private brandService: BrandingConfigurationService,
    private httpClient: HTTPWrapperContext,
    @Inject(MAT_DIALOG_DATA) public data: {
      npn: string;
      ffmId: string;
    },
    private dialogRef: MatDialogRef<NpnAndFFMChangeModalComponent>,
  ) { }

  get formControls(): FormControls {
    return this.npnAndFFMChangeForm.controls as unknown as FormControls;
  }
  get formControlsAsJson(): FormControlsAsJson {
    return this.npnAndFFMChangeForm.value as unknown as FormControlsAsJson;
  }
  ngOnInit(): void {
    this.npnAndFFMChangeForm = this.fb.group({
      npn1: this.fb.control(this.data.npn, [Validators.required]),
      npn2: this.fb.control(this.data.npn, [Validators.required, this.confirmNPN()]),
      ffm1: this.fb.control(this.data.ffmId, [Validators.required]),
      ffm2: this.fb.control(this.data.ffmId, [Validators.required, this.confirmFFMID()]),
      attestation: this.fb.control(false, [Validators.requiredTrue])
    });
  }

  async submit() {
    if (this.npnAndFFMChangeForm.valid) {
      const payload = {
        npnNo: this.formControlsAsJson.npn1,
        ffmId: this.formControlsAsJson.ffm1
      };

      const requestConfigImplementation = new RequestConfigImplementation({
        method: REQUEST_METHODS.PUT,
        url: `/cmcrst/x-services/proposal/npn`,
        headers: new HttpHeaders({
          ddToken: this.brandService.getCurrentBrand().ddToken_encoded()
        }),
        POST_OR_PUT_PAYLOAD: payload
      });

      this.httpClient.setStrategy(XHR_STRATEGIES.DATAPOWER_MIDDLEWARE);
      this.httpClient.disableErrorSnackbar(requestConfigImplementation);
      const response = await this.httpClient.makeRequest<unknown>(
        requestConfigImplementation
      );
      this.dialogRef.close();
    }
  }

  confirmNPN(): ValidatorFn {
    return (control: AbstractControl) => {
      if (control.value && control.value.length > 0) {
        if (control.value === this.npnAndFFMChangeForm?.controls['npn1'].value) { return null; }
        else {
          return { npnMatchFail: true };
        }
      } else {
        return null;
      }
    };
  }


  confirmFFMID(): ValidatorFn {
    return (control: AbstractControl) => {
      if (control.value && control.value.length > 0) {
        if (control.value === this.npnAndFFMChangeForm?.controls['ffm1'].value) { return null; }
        else {
          return { FFMIDMatchFail: true };
        }
      } else {
        return null;
      }
    };
  }

}
